import React from 'react';
import { useAtom, useSetAtom } from 'jotai';
import styles from './css/index.module.scss';
import CancellationReasonsHeader from './components/CancellationReasonsHeader';
import CancellationReasonsTable from './components/CancellationReasonsTable';
import CancellationReasonFormModal from './components/CancellationReasonFormModal';
import DeleteCancellationReasonModal from './components/DeleteCancellationReasonModal';
import useCancellationReasons from '../../hooks/UseCancellationReasons';
import { closeModalAtom, modalStateAtom } from '../../atoms/globalAtoms';

function CancellationReasons() {
  const {
    createCancellationReason,
    updateCancellationReason,
    deleteCancellationReason,
  } = useCancellationReasons();
  const [, setModalState] = useAtom(modalStateAtom);
  const closeModal = useSetAtom(closeModalAtom);

  const openAddModal = () => {
    setModalState({
      isOpen: true,
      children: (
        <CancellationReasonFormModal
          editItem={null}
          onSave={(name) => createCancellationReason(name)}
          onClose={closeModal}
        />
      ),
    });
  };

  const openEditModal = (item) => {
    setModalState({
      isOpen: true,
      children: (
        <CancellationReasonFormModal
          editItem={{ id: item.id, name: item.name }}
          onSave={(name) => updateCancellationReason(item.id, name)}
          onClose={closeModal}
        />
      ),
    });
  };

  const openDeleteModal = (item) => {
    setModalState({
      isOpen: true,
      children: (
        <DeleteCancellationReasonModal
          reasonName={item.name}
          onDelete={() => deleteCancellationReason(item.id)}
          onClose={closeModal}
        />
      ),
    });
  };

  return (
    <div className={styles.cancellationReasons}>
      <CancellationReasonsHeader onAddClick={openAddModal} />
      <CancellationReasonsTable onEdit={openEditModal} onDelete={openDeleteModal} />
    </div>
  );
}

export default CancellationReasons;
